import { Component } from "react";

import DataTable from "components/DigiHapi/DataTable";
import {
	DragTrComponent,
	DropTbodyComponent
} from "components/DigiHapi/DraggableTable";
import { DragDropContext } from "react-beautiful-dnd";

// @mui material components
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import Notification from "components/DigiHapi/Notification";

import { VscDebugStepInto } from "react-icons/vsc";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { fetchGetEquipments, fetchReorderEquipments } from "actions/equipment";

import { EQUIPMENTS_ON_DRAG_END } from "actions/types";
import { getSystemEquipments } from "selectors/equipment";

class PlacesOrderPage extends Component {
	state = {
		br: false,
		color: "info",
		message: null
	};

	componentDidMount() {
		const { fetchGetEquipments, community } = this.props;
		fetchGetEquipments(community._id);
	}

	componentDidUpdate(prevProps, prevState) {
		const { fetchGetEquipments, snackErrorMsg, snackInfoMsg, community } =
			this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			fetchGetEquipments(community._id);
			this.autoCloseMessage();
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	getEquipments = () => {
		const { equipments } = this.props;

		const equipmentsObj = equipments.map(({ _id, name }) => {
			return {
				_id,
				name
			};
		});
		return equipmentsObj;
	};

	handleDragEnd = result => {
		this.props.dispatch({
			type: EQUIPMENTS_ON_DRAG_END,
			result
		});
	};

	render() {
		const { color, message } = this.state;
		const {
			isFetching,
			isFetchingList,
			equipments,
			areEquipmentsReordered,
			fetchReorderEquipments,
			fetchGetEquipments,
			community
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							<VscDebugStepInto size={24} />
							<MDTypography variant="h6" color="white" ml={1.5}>
								Réorganiser les lieux de rendez-vous
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							{equipments.length > 0 && (
								<DragDropContext onDragEnd={this.handleDragEnd}>
									<DataTable
										TrComponent={DragTrComponent}
										TbodyComponent={DropTbodyComponent}
										data={this.getEquipments()}
										filterable
										columns={[
											{
												Header: "Nom",
												accessor: "name",
												sortable: false,
												filterable: false
											},
											{
												Header: "",
												accessor: "empty",
												sortable: false,
												filterable: false
											}
										]}
										loading={isFetchingList}
										defaultPageSize={equipments.length}
										showPaginationTop={false}
										showPaginationBottom={false}
										previousText="Précédent"
										nextText="Suivant"
										rowsText="Lignes"
										noDataText="Aucuns équipements"
										ofText="sur"
										loadingText="Chargement..."
									/>
								</DragDropContext>
							)}
						</MDBox>
						<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
							<MDButton
								variant="outlined"
								color="secondary"
								disabled={!areEquipmentsReordered}
								onClick={() => fetchGetEquipments(community._id)}
							>
								{"Restaurer"}
							</MDButton>
							<MDButton
								variant="gradient"
								color="primary"
								disabled={!areEquipmentsReordered}
								onClick={() => fetchReorderEquipments(equipments)}
							>
								{isFetching ? (
									<CircularProgress size={16} color="inherit" />
								) : (
									"Réorganiser"
								)}
							</MDButton>
						</MDBox>
					</Card>
				</Grid>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetchingList,
		isFetching,
		snackInfoMsg,
		snackErrorMsg,
		areEquipmentsReordered
	} = state.equipmentReducer;

	const { community } = state.entitiesReducer;

	return {
		isFetchingList,
		isFetching,
		equipments: Object.values(getSystemEquipments(state)),
		snackInfoMsg,
		snackErrorMsg,
		areEquipmentsReordered,
		community
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetEquipments,
			fetchReorderEquipments
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlacesOrderPage);
